/* --- Raw Speed Theme - storefront behavior --- */

function readThemeStrings() {
  const fallback = {
    addToCart: 'Add to bag',
    adding: 'Adding…',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    addError: 'This item could not be added. Please check your selection and try again.',
    addUncertain: 'We could not confirm the add. Please check your bag before trying again.',
    addedRefreshError: 'Item added, but the bag preview could not refresh. View your bag to confirm.',
    viewCart: 'View bag',
    cartError: 'There was an error while updating your bag. Please try again.',
    searchLoading: 'Searching…',
    searchNoProducts: 'No products found',
    searchViewAll: 'View all results',
    searchFor: 'See all results for “___Q___”',
    searchProducts: 'Related Products',
    searchCollections: 'Collections',
    searchError: 'Search is temporarily unavailable. Press Enter to see the full search page.',
    finderAddedRedirecting: 'Added to bag. Redirecting to your bag…'
  };

  try {
    const element = document.getElementById('theme-strings');
    return element ? Object.assign(fallback, JSON.parse(element.textContent)) : fallback;
  } catch (error) {
    console.error('Failed to parse theme strings', error);
    return fallback;
  }
}

const themeStrings = readThemeStrings();

window.KPTheme = window.KPTheme || {};
window.KPTheme.strings = themeStrings;
/* Market collection allowlist. Null on the UK storefront (show every
   collection Shopify returns). An array on /en-xx so search chips and
   predictive collection rows cannot send shoppers to the unavailable card. */
window.KPTheme.intlSoldHandles = Array.isArray(themeStrings.intlSoldHandles)
  ? themeStrings.intlSoldHandles
  : null;
/* Shopify shops can configure money_format as HTML, for example
   `<span class='money'>£{{amount}}</span>`. Every dynamic caller writes the
   formatted value with textContent (search, variant prices, cart totals), so
   retaining that wrapper exposes the literal tag to shoppers. Decode entities
   and keep only the visible format once, then let formatMoney return plain
   text consistently across every asynchronous surface. */
var kpMoneyFormatHolder = document.createElement('span');
kpMoneyFormatHolder.innerHTML = themeStrings.moneyFormat || '£{{amount}}';
window.KPTheme.moneyFormat = kpMoneyFormatHolder.textContent || '£{{amount}}';
window.KPTheme.hydrateLazyAppSection = hydrateLazyAppSection;
window.KPTheme.track = window.KPTheme.track || function () {};

/* Same symbols as Liquid `| money`. Intl with lang=en + AUD prints A$,
   which is why drawer recs disagreed with the PDP and cart line prices. */
window.KPTheme.formatMoney = function (cents) {
  var format = window.KPTheme.moneyFormat || '£{{amount}}';
  var value = '';
  var placeholder = /\{\{\s*(\w+)\s*\}\}/;
  var match = format.match(placeholder);
  var amount = Number(cents);
  if (!isFinite(amount)) amount = 0;

  function withDelimiters(number, precision, thousands, decimal) {
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;
    precision = precision === undefined ? 2 : precision;
    var num = (number / 100).toFixed(precision);
    var parts = num.split('.');
    var major = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var minor = parts[1] ? decimal + parts[1] : '';
    return major + minor;
  }

  switch (match ? match[1] : 'amount') {
    case 'amount_no_decimals':
      value = withDelimiters(amount, 0);
      break;
    case 'amount_with_comma_separator':
      value = withDelimiters(amount, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = withDelimiters(amount, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = withDelimiters(amount, 2, "'", '.');
      break;
    case 'amount_with_space_separator':
      value = withDelimiters(amount, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = withDelimiters(amount, 0, ' ', '.');
      break;
    default:
      value = withDelimiters(amount, 2);
  }
  return format.replace(placeholder, value);
};

/* iOS Safari ignores overflow:hidden on body. position:fixed + saved
   scrollY is the lock search already uses. Cart, menu and filters share
   it so one overlay cannot leave the page rubber-banding underneath. */
var kpBodyLockY = 0;
var kpBodyLockOwner = null;
window.KPTheme.lockBody = function (owner) {
  if (kpBodyLockOwner) return;
  kpBodyLockOwner = owner || 'default';
  kpBodyLockY = window.scrollY || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + kpBodyLockY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.maxWidth = '100%';
  document.body.style.overflow = 'hidden';
};
window.KPTheme.unlockBody = function (owner) {
  if (kpBodyLockOwner && owner && kpBodyLockOwner !== owner) return;
  kpBodyLockOwner = null;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.maxWidth = '';
  document.body.style.overflow = '';
  window.scrollTo(0, kpBodyLockY);
};

document.addEventListener('DOMContentLoaded', () => {
  initHeader(document);
  initLazyAppSections();
});

/* Shopify replaces the header section's DOM wholesale when it's edited in
   the theme editor — the drawer/search/sticky listeners bound above are
   then attached to nodes that no longer exist. Re-run against the new DOM,
   scoped to sections that actually contain header markup so an unrelated
   section reload (e.g. a homepage block) does no extra work. */
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.menu-drawer, .mobile-search-overlay, .site-header, .header')) {
    initHeader(event.target);
  }
  if (event.target.querySelector('[data-lazy-app-section]')) {
    initLazyAppSections(event.target);
  }
});

function initHeader(root) {
  initStickyHeader();
  initMobileDrawer(root);
  initMobileSearch(root);
  initMegaMenuImages(root);
}

/* --- Mega-menu preview images ---
   The desktop dropdown is opacity:0 + visibility:hidden until hover, which
   means loading="lazy" never fired for the preview thumbnails — measured on
   the live homepage, 0 of 24 had loaded before the first hover, so the menu
   opened onto empty squares every time. Marking them eager instead would
   pull 24 images into every single page load for a menu most visitors never
   open, so they carry data-src and hydrate the first time their department
   is hovered or focused. Same approach initMobileDrawer already uses for the
   mobile menu's images. */
function initMegaMenuImages(root) {
  const scope = root || document;
  scope.querySelectorAll('.desktop-nav .nav-item').forEach((item) => {
    if (item.dataset.megaImagesBound === 'true') return;
    item.dataset.megaImagesBound = 'true';
    const hydrate = () => {
      item.querySelectorAll('img[data-src]').forEach((image) => {
        const src = image.dataset.src;
        if (!src) return;
        image.src = src;
        image.removeAttribute('data-src');
      });
    };
    // once:true — after the first reveal the images are in the DOM for good.
    item.addEventListener('mouseenter', hydrate, { once: true });
    item.addEventListener('pointerenter', hydrate, { once: true });
    item.addEventListener('focusin', hydrate, { once: true });

    /* New-page load with the cursor already sitting on this department:
       CSS :hover opens the panel immediately, but mouseenter does not
       fire again, so data-src never became src and the thumbs painted as
       broken images. If this item is already hovered or focused, hydrate
       now (and again on the next frame in case :hover is applied after
       the deferred script). */
    const hydrateIfOpen = () => {
      if (item.matches(':hover') || item.matches(':focus-within')) hydrate();
    };
    hydrateIfOpen();
    requestAnimationFrame(hydrateIfOpen);

    /* A panel is held open while focus sits inside it (keyboard support,
       :has(:focus-visible) in the CSS). If that focus is stale — a
       right-click inside a panel, or a keyboard user switching to the
       mouse — the held panel stacks UNDER the next hovered department
       (seen live 27 Aug 2026, Fan Gear pinned under Wall Beds). Entering
       another department with the mouse is an unambiguous "I've moved on",
       so release focus held inside any other nav item. Keyboard-only
       flows never fire mouseenter and are unaffected. */
    item.addEventListener('mouseenter', () => {
      const active = document.activeElement;
      if (!active) return;
      const owner = active.closest('.desktop-nav .nav-item');
      if (owner && owner !== item) active.blur();
    });
  });
}

/* --- Sticky compact header ---
   Toggles .is-stuck past 120px of scroll; header-premium.css does the rest.
   Without that class the CSS is inert, so this is the only behavioural
   addition in the header restyle.

   The window scroll listener is bound exactly once (module-level guard)
   and re-queries the header element on every tick instead of closing over
   it. A header reload in the theme editor calling this again must not
   stack a second permanent window listener that keeps referencing the
   detached pre-reload header forever. */
let stickyHeaderBound = false;
function initStickyHeader() {
  if (stickyHeaderBound) return;
  stickyHeaderBound = true;
  let stuck = false;
  let ticking = false;
  const apply = () => {
    ticking = false;
    const header = document.querySelector('.site-header, .header');
    if (!header) return;
    const next = window.scrollY > 120;
    if (next === stuck) return;
    stuck = next;
    header.classList.toggle('is-stuck', next);
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  };
  /* No sync apply() on bind — avoids competing with first paint / LCP. */
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* --- Defer heavy below-fold app sections until they are needed --- */
function hydrateLazyAppSection(section) {
  if (!section || section.dataset.loaded === 'true') return;

  const template = section.querySelector('template[data-lazy-app-template]');
  if (!template) return;

  section.dataset.loaded = 'true';
  section.appendChild(template.content.cloneNode(true));
  template.remove();
}

function initLazyAppSections(root) {
  const scope = root || document;
  const sections = Array.prototype.filter.call(
    scope.querySelectorAll('[data-lazy-app-section]'),
    (section) => section.dataset.lazyObserved !== 'true'
  );
  if (!sections.length) return;
  sections.forEach((section) => { section.dataset.lazyObserved = 'true'; });

  if (window.Shopify?.designMode) {
    sections.forEach(hydrateLazyAppSection);
    return;
  }

  if (!('IntersectionObserver' in window)) {
    sections.forEach(hydrateLazyAppSection);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      hydrateLazyAppSection(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '800px 0px' });

  sections.forEach((section) => observer.observe(section));

  /* FIRST-VISIT FALLBACK (23 Aug 2026).
     The observed element is a bare wrapper around an inert <template>, so it
     has ZERO height until it hydrates. A zero-area target is an edge case for
     IntersectionObserver, and the reported symptom was reviews appearing only
     after tapping the star rating - which works because product-controller.js
     calls hydrateLazyAppSection() directly on that click.

     The fix must NOT give the placeholder a min-height: on products with no
     Loox reviews the widget renders nothing, and a reserved height puts back
     the large empty gap that was already fixed once.

     So instead: hydrate on the visitor's first scroll, during idle time. Same
     pattern as the chat bundle. Costs no layout, reserves no space, and still
     keeps the app off the critical path for LCP - nobody scrolls before the
     hero paints. The observer stays as the primary trigger; this only catches
     the case where it never fires. */
  const pending = sections.slice();
  let released = false;
  const releaseAll = () => {
    if (released) return;
    released = true;
    window.removeEventListener('scroll', releaseAll);
    const run = () => pending.forEach((section) => {
      hydrateLazyAppSection(section);
      observer.unobserve(section);
    });
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 300);
    }
  };
  window.addEventListener('scroll', releaseAll, { passive: true, once: true });
}

/* --- Mobile Drawer Menu Toggler --- */
function initMobileDrawer(root) {
  const scope = root || document;
  const openBtn = scope.querySelector('.btn-menu-open');
  const closeBtn = scope.querySelector('.btn-menu-close');
  const drawer = scope.querySelector('.menu-drawer');
  const overlay = scope.querySelector('.menu-drawer-overlay');
  let returnFocus = null;

  if (!drawer || drawer.dataset.mobileDrawerInitialized === 'true') return;
  drawer.dataset.mobileDrawerInitialized = 'true';

  const content = drawer.querySelector('.menu-drawer-content');
  const updateScrollCue = () => {
    if (!content) return;
    const canScroll = content.scrollHeight > content.clientHeight + 4;
    const atEnd = content.scrollTop + content.clientHeight >= content.scrollHeight - 12;
    content.classList.toggle('is-scrollable', canScroll);
    content.classList.toggle('is-at-end', !canScroll || atEnd);
  };
  content?.addEventListener('scroll', updateScrollCue, { passive: true });
  if (typeof ResizeObserver !== 'undefined' && content) {
    new ResizeObserver(updateScrollCue).observe(content);
  }

  const openHeaderAccount = () => {
    const host = document.querySelector('.header-actions shopify-account');
    if (!host) return;
    const inner = host.shadowRoot && host.shadowRoot.querySelector('button, [aria-haspopup="dialog"]');
    const slot = host.querySelector('[slot="signed-out-avatar"]');
    (inner || slot || host).click();
  };

  const toggleDrawer = (state) => {
    returnFocus = state ? document.activeElement : returnFocus;
    if (state) {
      drawer.querySelectorAll('img[data-src]').forEach((image) => {
        image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');
      });
      content?.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', updateScrollCue, { once: true });
      });
    }
    drawer.classList.toggle('open', state);
    overlay.classList.toggle('open', state);
    drawer.toggleAttribute('inert', !state);
    drawer.setAttribute('aria-hidden', String(!state));
    openBtn?.setAttribute('aria-expanded', String(state));
    if (state) window.KPTheme.lockBody('menu');
    else window.KPTheme.unlockBody('menu');
    if (state) {
      closeBtn?.focus();
      requestAnimationFrame(updateScrollCue);
      setTimeout(updateScrollCue, 80);
    } else {
      returnFocus?.focus();
    }
  };

  openBtn?.addEventListener('click', () => toggleDrawer(true));
  closeBtn?.addEventListener('click', () => toggleDrawer(false));
  overlay?.addEventListener('click', () => toggleDrawer(false));
  drawer.querySelector('[data-kp-open-account]')?.addEventListener('click', () => {
    toggleDrawer(false);
    const go = () => openHeaderAccount();
    if (window.customElements && !customElements.get('shopify-account')) {
      customElements.whenDefined('shopify-account').then(go);
    } else {
      requestAnimationFrame(go);
    }
  });
  /* Tab was free to walk out of the drawer into the page behind the
     overlay — the cart drawer already traps focus the same way (see
     assets/cart-drawer.js), this menu drawer just never got it. */
  var FOCUSABLE_SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  drawer.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { toggleDrawer(false); return; }
    if (event.key !== 'Tab' || !drawer.classList.contains('open')) return;
    const focusables = Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE_SEL),
      (n) => n.offsetParent !== null || n === document.activeElement
    );
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    const withinDrawer = drawer.contains(document.activeElement);
    if (event.shiftKey) {
      if (!withinDrawer || document.activeElement === first) { event.preventDefault(); last.focus(); }
    } else {
      if (!withinDrawer || document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
}

/* --- Mobile Search Overlay Toggler ---
   The scroll-to-close behavior is bound to `window` exactly once
   (module-level guard below) and always re-queries the live overlay/input,
   rather than closing over the specific elements this particular init call
   saw — otherwise a header reload in the theme editor would leave the old
   listener permanently attached, checking a detached overlay on every
   future scroll for the rest of the pageview. */
let mobileSearchScrollBound = false;
let mobileSearchOpenedAtScrollY = 0;
let mobileSearchReturnFocus = null;
let mobileSearchHistPushed = false;
let mobileSearchPopBound = false;
let mobileSearchVvBound = false;
let mobileSearchBodyY = 0;

function resetIosSearchZoom() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  const base = 'width=device-width,initial-scale=1';
  meta.setAttribute('content', base + ',maximum-scale=1');
  window.setTimeout(() => meta.setAttribute('content', base), 60);
}

function pinMobileSearchOverlay() {
  const overlay = document.querySelector('.mobile-search-overlay');
  if (!overlay || !overlay.classList.contains('open')) return;
  const vv = window.visualViewport;
  const offsetTop = vv ? vv.offsetTop : 0;
  const offsetLeft = vv ? vv.offsetLeft : 0;
  const viewportH = vv ? vv.height : window.innerHeight;
  /* Overlay lives on <html>, not inside body, so body position:fixed
     (the scroll lock) cannot become its containing block. Pin to the
     visual viewport only — never add the locked scrollY, or the bar
     renders above the screen after the visitor has scrolled. */
  overlay.style.top = Math.round(offsetTop) + 'px';
  overlay.style.left = Math.round(offsetLeft) + 'px';
  overlay.style.right = '0';
  overlay.style.width = '';
  overlay.style.height = 'auto';
  overlay.style.maxHeight = 'none';
  overlay.style.paddingTop = offsetTop > 1 ? '0px' : '';
  overlay.style.paddingBottom = '0px';
  overlay.style.transform = 'none';

  const bar = overlay.querySelector('.mobile-search-overlay__bar');
  /* If the bar is above the visual viewport, iOS is still using the
     locked body as the overlay's containing block. Shift by the lock
     offset so the bar (and dim) land on screen. */
  if (bar && bar.getBoundingClientRect().top < offsetTop - 20) {
    const lockedY = Math.abs(parseFloat(document.body.style.top)) || mobileSearchBodyY || 0;
    overlay.style.top = Math.round(lockedY + offsetTop) + 'px';
  }

  const panel = overlay.querySelector('.mobile-search-overlay__panel');
  if (!panel) return;
  const barBottom = bar ? bar.getBoundingClientRect().bottom : 64;
  const used = barBottom - offsetTop;
  const safariChrome = 12;
  const available = Math.max(160, Math.round(viewportH - used - safariChrome));
  panel.style.maxHeight = available + 'px';
}

function unpinMobileSearchOverlay() {
  const overlay = document.querySelector('.mobile-search-overlay');
  if (!overlay) return;
  overlay.style.top = '';
  overlay.style.left = '';
  overlay.style.right = '';
  overlay.style.width = '';
  overlay.style.height = '';
  overlay.style.maxHeight = '';
  overlay.style.paddingTop = '';
  overlay.style.paddingBottom = '';
  overlay.style.transform = '';
  const panel = overlay.querySelector('.mobile-search-overlay__panel');
  if (panel) panel.style.maxHeight = '';
}

function lockMobileSearchBody() {
  if (document.body.classList.contains('kp-search-open')) return;
  mobileSearchBodyY = window.scrollY || 0;
  document.body.classList.add('kp-search-open');
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + mobileSearchBodyY + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.maxWidth = '100%';
  document.body.style.overflow = 'hidden';
}

function unlockMobileSearchBody() {
  if (!document.body.classList.contains('kp-search-open')) return;
  document.body.classList.remove('kp-search-open');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.maxWidth = '';
  document.body.style.overflow = '';
  window.scrollTo(0, mobileSearchBodyY);
}

function closeMobileSearch(restoreFocus, fromPopstate) {
  const overlay = document.querySelector('.mobile-search-overlay');
  if (!overlay) return;
  const wasOpen = overlay.classList.contains('open');
  const openBtn = document.querySelector('.btn-search-open');
  const searchInput = overlay.querySelector('input[type="search"]');
  overlay.classList.remove('open');
  unpinMobileSearchOverlay();
  unlockMobileSearchBody();
  resetIosSearchZoom();
  overlay.setAttribute('inert', '');
  overlay.setAttribute('aria-hidden', 'true');
  openBtn?.setAttribute('aria-expanded', 'false');
  if (searchInput) {
    searchInput.blur();
    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    const resultsBox = overlay.querySelector('.predictive-search-results');
    if (resultsBox) {
      resultsBox.replaceChildren();
      resultsBox.classList.add('hidden');
    }
    const panel = overlay.querySelector('.mobile-search-overlay__panel');
    if (panel) panel.classList.remove('is-open');
    const clearBtn = overlay.querySelector('.mobile-search-overlay__clear');
    if (clearBtn) clearBtn.hidden = true;
  }
  if (restoreFocus !== false) mobileSearchReturnFocus?.focus({ preventScroll: true });
  if (wasOpen && mobileSearchHistPushed && !fromPopstate && history.state && history.state.kpMobileSearch) {
    mobileSearchHistPushed = false;
    history.back();
  } else {
    mobileSearchHistPushed = false;
  }
}

let mobileSearchOpenedAt = 0;

function initMobileSearch(root) {
  const scope = root || document;
  const openBtn = scope.querySelector('.btn-search-open');
  const overlay = scope.querySelector('.mobile-search-overlay');
  if (!overlay || overlay.dataset.mobileSearchInitialized === 'true') return;
  overlay.dataset.mobileSearchInitialized = 'true';
  /* Body scroll-lock uses position:fixed. On iOS that makes the body the
     containing block for every position:fixed descendant, so after the
     visitor has scrolled the overlay paints at document-top — off screen.
     Keyboard still focuses the input, so it looks like "search opened
     but nothing is visible". Park the overlay on <html> once. Theme
     editor section reloads can inject a second copy — keep one. */
  document.querySelectorAll('.mobile-search-overlay').forEach((node) => {
    if (node !== overlay) node.remove();
  });
  if (overlay.parentNode !== document.documentElement) {
    document.documentElement.appendChild(overlay);
  }
  const closeBtn = overlay.querySelector('.btn-search-close');
  const backdrop = overlay.querySelector('.mobile-search-overlay__backdrop');
  const searchInput = overlay.querySelector('input[type="search"]');
  const clearBtn = overlay.querySelector('.mobile-search-overlay__clear');

  function syncSearchClear() {
    if (!clearBtn || !searchInput) return;
    clearBtn.hidden = searchInput.value.trim().length === 0;
  }

  function openMobileSearch() {
    mobileSearchReturnFocus = document.activeElement;
    mobileSearchOpenedAtScrollY = window.scrollY;
    mobileSearchOpenedAt = Date.now();
    lockMobileSearchBody();
    overlay.removeAttribute('inert');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
    pinMobileSearchOverlay();
    requestAnimationFrame(pinMobileSearchOverlay);
    window.setTimeout(pinMobileSearchOverlay, 280);
    window.setTimeout(pinMobileSearchOverlay, 600);
    openBtn?.setAttribute('aria-expanded', 'true');
    openBtn?.classList.add('is-pressed');
    window.setTimeout(() => openBtn?.classList.remove('is-pressed'), 180);
    // Keep focus inside the original tap event so iOS opens the keyboard
    // immediately and does not scroll toward an off-screen transitioning input.
    searchInput?.focus({ preventScroll: true });
    if (!mobileSearchHistPushed) {
      history.pushState({ kpMobileSearch: 1 }, '');
      mobileSearchHistPushed = true;
    }
  }

  /* pointerup catches finger lifts that sometimes never fire a full click on
     iOS when the header reflows; still ignore non-primary buttons. */
  openBtn?.addEventListener('pointerup', (event) => {
    if (event.button != null && event.button !== 0) return;
    if (overlay.classList.contains('open')) return;
    event.preventDefault();
    openMobileSearch();
  });
  openBtn?.addEventListener('click', (event) => {
    if (overlay.classList.contains('open')) return;
    event.preventDefault();
    openMobileSearch();
  });

  closeBtn?.addEventListener('click', () => closeMobileSearch(true));
  backdrop?.addEventListener('click', () => closeMobileSearch(true));
  clearBtn?.addEventListener('click', () => {
    if (!searchInput) return;
    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    syncSearchClear();
    searchInput.focus({ preventScroll: true });
  });
  overlay.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileSearch(true);
  });

  if (!mobileSearchPopBound) {
    mobileSearchPopBound = true;
    window.addEventListener('popstate', () => {
      const liveOverlay = document.querySelector('.mobile-search-overlay');
      if (liveOverlay && liveOverlay.classList.contains('open')) {
        /* Capture so collection-grid.js does not reload over iOS Back. */
        window.__kpMobileSearchPop = true;
        closeMobileSearch(false, true);
        window.setTimeout(function () { window.__kpMobileSearchPop = false; }, 0);
      }
    }, true);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) closeMobileSearch(false, true);
      resetIosSearchZoom();
    });
  }

  searchInput?.addEventListener('focus', pinMobileSearchOverlay);
  searchInput?.addEventListener('input', () => {
    syncSearchClear();
    requestAnimationFrame(pinMobileSearchOverlay);
    window.setTimeout(pinMobileSearchOverlay, 350);
  });
  searchInput?.addEventListener('blur', () => {
    requestAnimationFrame(pinMobileSearchOverlay);
    window.setTimeout(pinMobileSearchOverlay, 300);
  });

  if (!mobileSearchVvBound) {
    mobileSearchVvBound = true;
    window.addEventListener('resize', pinMobileSearchOverlay);
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', pinMobileSearchOverlay);
      visualViewport.addEventListener('scroll', pinMobileSearchOverlay);
    }
  }

  if (!mobileSearchScrollBound) {
    mobileSearchScrollBound = true;
    window.addEventListener('scroll', () => {
      const liveOverlay = document.querySelector('.mobile-search-overlay');
      const liveInput = liveOverlay?.querySelector('input[type="search"]');
      /* Ignore scroll for 500ms after open: iOS focus/keyboard and the overlay
         slide often nudge scrollY by >8px, which used to close search on the
         same tap that opened it (green flash, bar never stays open). */
      if (Date.now() - mobileSearchOpenedAt < 500) return;
      if (
        liveOverlay?.classList.contains('open') &&
        !liveInput?.value.trim() &&
        Math.abs(window.scrollY - mobileSearchOpenedAtScrollY) > 24
      ) {
        closeMobileSearch(false);
      }
    }, { passive: true });
  }
}
